import React, { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/layout/Layout";
import CartSheet from "@/components/Cart";
import CookieBanner from "@/components/CookieBanner";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import { LOCATION_ENABLED } from "@/lib/features";
const MiniPelles = lazy(() => import("@/pages/MiniPelles"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const MandatImport = lazy(() => import("@/pages/MandatImport"));
const MandatModelDetail = lazy(() => import("@/pages/MandatModelDetail"));
const Location = lazy(() => import("@/pages/Location"));
const Accessoires = lazy(() => import("@/pages/Accessoires"));
const PiecesDetachees = lazy(() => import("@/pages/PiecesDetachees"));
const PieceDetail = lazy(() => import("@/pages/PieceDetail"));
const Contact = lazy(() => import("@/pages/Contact"));
const BlogList = lazy(() => import("@/pages/Blog").then((m) => ({ default: m.BlogList })));
const BlogPost = lazy(() => import("@/pages/Blog").then((m) => ({ default: m.BlogPost })));
const CGV = lazy(() => import("@/pages/CGV"));
const Occasions = lazy(() => import("@/pages/Occasions"));
const OccasionDetail = lazy(() => import("@/pages/OccasionDetail"));
const CommandeConfirmation = lazy(() => import("@/pages/CommandeConfirmation"));
const CommandeAnnulee = lazy(() => import("@/pages/CommandeConfirmation").then((m) => ({ default: m.CommandeAnnulee })));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="bottom-left" richColors />
            <CartSheet />
            <CookieBanner />
            <Analytics />
            <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/mini-pelles" element={<MiniPelles />} />
                <Route path="/mini-pelles/:slug" element={<ProductDetail kind="mini-pelle" />} />
                <Route path="/mandat-import" element={<MandatImport />} />
                <Route path="/mandat-import/:slug" element={<MandatModelDetail />} />
                <Route path="/location" element={LOCATION_ENABLED ? <Location /> : <Navigate to="/" replace />} />
                <Route path="/mini-pelles-occasion" element={<Occasions />} />
                <Route path="/mini-pelles-occasion/:slug" element={<OccasionDetail />} />
                <Route path="/accessoires" element={<Accessoires />} />
                <Route path="/pieces-detachees" element={<PiecesDetachees />} />
                <Route path="/pieces-detachees/:slug" element={<PieceDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/faq" element={<Navigate to="/contact" replace />} />
                <Route path="/cgv" element={<CGV />} />
                <Route path="/commande/confirmation" element={<CommandeConfirmation />} />
                <Route path="/commande/annulee" element={<CommandeAnnulee />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            </Suspense>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
